module.exports = __webpack_public_path__ + "img/alan.721a73cb.jpg";